import { Loader } from '@zeeve-platform/loader-component';
import loader from '../../images/spinner.svg';

const Loading = () => (
  <Loader
    imagePath={loader}
  />
);

export default Loading;